import { createAction, createAsyncAction } from 'typesafe-actions'
import {
  ReadUserReferralsRequestDto,
  ReadUserReferralsResponseDto,
  UserChangeIntroducerDataRequestDto,
  UserIntroducerResponseDto,
  ReadUsersForReassignIntroducerResponseDto,
  DeleteUserReferralRequestDto,
  DeleteUserReferralResponseDto,
  UpdateUserReferralRequestDto,
  UpdateUserReferralResponseDto,
  CreateUserReferralRequestDto,
  CreateUserReferralResponseDto,
  IUser,
} from '@sparling/financial-common'

export const {
  request: getIntroducerUsersRequest,
  success: getIntroducerUsersSuccess,
  failure: getIntroducerUsersFailure,
} = createAsyncAction('GET_INTRODUCER_USERS_REQUEST', 'GET_INTRODUCER_USERS_SUCCESS', 'GET_INTRODUCER_USERS_FAILURE')<
  ReadUserReferralsRequestDto,
  ReadUserReferralsResponseDto,
  Error
>()

export const {
  request: deleteIntroducerUserRequest,
  success: deleteIntroducerUserSuccess,
  failure: deleteIntroducerUserFailure,
} = createAsyncAction(
  'DELETE_INTRODUCER_USER_REQUEST',
  'DELETE_INTRODUCER_USER_SUCCESS',
  'DELETE_INTRODUCER_USER_FAILURE',
)<DeleteUserReferralRequestDto, DeleteUserReferralResponseDto, Error>()

export const {
  request: introducerDataUpdateRequest,
  success: introducerDataUpdateSuccess,
  failure: introducerDataUpdateFailure,
} = createAsyncAction(
  'INTRODUCER_DATA_UPDATE_REQUEST',
  'INTRODUCER_DATA_UPDATE_SUCCESS',
  'INTRODUCER_DATA_UPDATE_FAILURE',
)<{ idSf: string } & UserChangeIntroducerDataRequestDto, UserIntroducerResponseDto, Error>()

export const {
  request: fetchUsersForReassignRequest,
  success: fetchUsersForReassignSuccess,
  failure: fetchUsersForReassignFailure,
} = createAsyncAction(
  'FETCH_USERS_FOR_REASSIGNING_REQUEST',
  'FETCH_USERS_FOR_REASSIGNING_SUCCESS',
  'FETCH_USERS_FOR_REASSIGNING_FAILURE',
)<void, ReadUsersForReassignIntroducerResponseDto, Error>()

export const {
  request: getAssignableReferralsRequest,
  success: getAssignableReferralsSuccess,
  failure: getAssignableReferralsFailure,
} = createAsyncAction(
  'GET_ASSIGNABLE_REFERRALS_REQUEST',
  'GET_ASSIGNABLE_REFERRALS_SUCCESS',
  'GET_ASSIGNABLE_REFERRALS_FAILURE',
)<void, IUser[], Error>()

export const {
  request: assignIntroducerUserRequest,
  success: assignIntroducerUserSuccess,
  failure: assignIntroducerUserFailure,
} = createAsyncAction(
  'ASSIGN_INTRODUCER_USER_REQUEST',
  'ASSIGN_INTRODUCER_USER_SUCCESS',
  'ASSIGN_INTRODUCER_USER_FAILURE',
)<CreateUserReferralRequestDto, CreateUserReferralResponseDto, Error>()

export const {
  request: reassignIntroducerUserRequest,
  success: reassignIntroducerUserSuccess,
  failure: reassignIntroducerUserFailure,
} = createAsyncAction(
  'REASSIGN_INTRODUCER_USER_REQUEST',
  'REASSIGN_INTRODUCER_USER_SUCCESS',
  'REASSIGN_INTRODUCER_USER_FAILURE',
)<UpdateUserReferralRequestDto, UpdateUserReferralResponseDto, Error>()

export const canUpdateUserDetails = createAction('INTRODUCER_CAN_UPDATE_USER_DETAILS')<boolean>()
